import { useFormContext } from 'react-hook-form';
import { RecordFilter } from '@/types/api';
import FileItem from '@/components/Record/SubjectContent/AttachmentFile/FileContent/FileItem';

type P = {
  fileName: string;
  uuid: string;
  fileSize: string;
};

const FileContent = ({ fileName, uuid, fileSize }: P) => {
  const { getValues, setValue } = useFormContext<RecordFilter>();
  const handleDelete = () => {
    const before = getValues('attachments');
    setValue(
      'attachments',
      before.filter((f) => f.uuid !== uuid),
    );
  };
  return (
    <FileItem
      fileName={fileName}
      handleDelete={handleDelete}
      uuid={uuid}
      fileSize={fileSize}
    />
  );
};

export default FileContent;
